import React, { useEffect, useState } from "react";
import "./index.scss";
import LoginHead from "../../assets/login-head.png";
import Logo from "../../assets/logo.png";
import { Col, Row } from "antd";
import { Button, Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../store/apis/users";

function Login() {
  const usersState = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinishForm = (values) => {
    dispatch(loginUser(values));
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      navigate("/");
    }
  }, [usersState]);

  return (
    <div className="login-container">
      <Row>
        <Col xs={4} sm={4} md={10} lg={9} xl={9}>
          <div className="login-head-section">
            <Link to="/">
              <img src={Logo} className="logo-img" />
            </Link>
            <img src={LoginHead} className="head-img" />
          </div>
        </Col>
        <Col xs={4} sm={4} md={14} lg={15} xl={15}>
          <div className="login-form-section">
            <div className="login-form">
              <div className="form-card">
                <h2> تسجيل الدخول </h2>
                <Form
                  name="basic"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  style={{
                    maxWidth: 600,
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinishForm}
                  autoComplete="off"
                >
                  <Form.Item
                    name="email"
                    wrapperCol={{
                      offset: 0,
                      span: 24,
                    }}
                    rules={[
                      {
                        type: "email",
                        message:
                          "مثل الرجاء إدخال البريد الإلكتروني الصحيح! مثل example@example.com",
                      },
                      {
                        required: true,
                        message: "الرجاء إدخال الإلكتروني!",
                      },
                    ]}
                    type="email"
                  >
                    <Input
                      className="email-input"
                      placeholder="البريد الإلكتروني"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    wrapperCol={{
                      offset: 0,
                      span: 24,
                    }}
                    rules={[
                      {
                        required: true,
                        message: "الرجاء إدخال كلمة المرور!",
                      },
                    ]}
                  >
                    <Input.Password placeholder="كلمة المرور" />
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      offset: 0,
                      span: 24,
                    }}
                  >
                    <span> نسيت كلمة المرور ؟ </span>
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      offset: 4,
                      span: 24,
                    }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-submit-button"
                    >
                      تسجيل الدخول
                    </Button>
                  </Form.Item>
                </Form>
                <div className="go-register">
                  <span>
                    هل لديك حساب؟
                    <Link to="/register"> إنشاء حساب </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Login;
